import React from 'react';
import { useTranslation } from 'react-i18next';

import Button from '../../../components/Button';
import useClasses from '../../../hooks/useClasses';
import { useModalContext } from '../Context';

import './style.scss';

export interface ModalActionsProps {
  backTitle?: string;
  primaryActionTitle?: string;
  secondaryActionTitle?: string;
  className?: string;
  onBack?: () => void;
  onPrimaryAction: () => void;
  onSecondaryAction?: () => void;
}

const ModalActions: React.FC<ModalActionsProps> = (props) => {
  const {
    backTitle,
    primaryActionTitle,
    secondaryActionTitle,
    className,
    onBack,
    onPrimaryAction,
    onSecondaryAction,
  } = props;

  const { actionsRef } = useModalContext();

  const { buildClass, joinClasses } = useClasses('Modal__Actions');

  const { t } = useTranslation();

  return (
    <footer className={joinClasses(buildClass(), className)} ref={actionsRef}>
      {onBack && (
        <div className={buildClass('left')}>
          <Button inverted onClick={onBack}>
            {backTitle || t('buttons.back')}
          </Button>
        </div>
      )}

      <div className={buildClass('right')}>
        {(secondaryActionTitle && onSecondaryAction) && (
          <Button inverted onClick={onSecondaryAction}>
            {secondaryActionTitle}
          </Button>
        )}

        <Button onClick={onPrimaryAction}>
          {primaryActionTitle || t('buttons.next')}
        </Button>
      </div>
    </footer>
  );
};

export default ModalActions;
